
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";
import { MessageBox } from "element-ui";

import { CardDto, UserCardDto } from "@/api/appService";

import EditBaseCard from "./components/edit-baseCard.vue";
import EditBaseCardSku from "./components/edit-baseCardSku.vue";

@Component({
  name: "CardList",
  components: {
    EditBaseCard,
    EditBaseCardSku
  }
})
export default class AdminCardList extends ElementTableView {
  @Ref() editCardSku!: EditBaseCardSku;
  @Ref() editBaseCard!: EditBaseCard;

  tableItems: CardDto[] = [];

  async created() {
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.baseCard.getAll().then(res => {
      console.log(res);
      this.table.listLoading = false;
      this.tableItems = res;
    });
  }

  // 新建
  handleCreate() {
    this.editBaseCard.show = true;
  }

  // 编辑
  handleEdit(index: number, row: CardDto) {
    this.editBaseCard.show = true;
    this.editBaseCard.form = row;
  }

  // 编辑SKU
  handleEditSku(row: CardDto) {
    this.editCardSku.show = true;
    this.editCardSku.form = row;
  }

  // 编辑SKU
  async handleSync(row: CardDto) {
    await api.baseCard
      .syncCard({
        body: {
          id: row.id
        }
      })
      .then(async res => {
        this.$message({
          type: "success",
          message: "同步已完成，信息已更新至所有分店"
        });
        await this.fetchData();
      });
  }

  // 删除
  async handleDelete(index: number, row: CardDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.card
        .delete({
          id: row.id
        })
        .then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.fetchData();
        });
    });
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
